import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthModal } from '@features/common/protected-auth-route/model.ts';
import { useUser } from '@shared/hooks';
import { eventService } from 'library/api/eventService';
import type { TicketDetail } from 'library/models/events';
import useWindowDimensions from '../common/useWindowDimensions';

const useMyTickets = () => {
  const { openAuth } = useAuthModal();
  const [tickets, setTickets] = React.useState<TicketDetail[]>([]);
  const [status, setStatus] = React.useState('idle');
  const { id, code } = useParams<{ id: string; code: string }>();
  const navigate = useNavigate();
  const { isAuth } = useUser();
  const { width } = useWindowDimensions();
  const showCloseBtn = width <= 1024;

  const getTickets = React.useCallback(async () => {
    setStatus('loading');
    try {
      const response = await eventService.getTicketsList(id);
      if (!response.data) {
        throw response;
      }

      setTickets(response.data);
    } catch (error) {
      // console.log(error);
    }
    setStatus('loaded');
  }, [id]);

  React.useEffect(() => {
    isAuth && status === 'idle' && getTickets();
  }, [getTickets, status, isAuth]);

  const onClose = () => {
    navigate(`/events/${code}/${id}`);
  };

  const onBuy = () => {
    isAuth ? navigate(`/events/${code}/${id}/buy`) : openAuth();
  };

  return {
    tickets,
    status,
    onClose,
    onBuy,
    isAuth,
    showCloseBtn,
  };
};

export default useMyTickets;
